import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Header } from 'components/header/Header';

const Nav = () => {
  const headerLabels = useMemo(
    () => [
      { title: '가이드', link: '/guide' },
      { title: '멤버십', link: '/membership' },
      { title: '고객센터', link: '/customercenter' }
    ],
    []
  );

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const initialSelectedTab = useMemo(() => {
    const index = headerLabels.findIndex(({ link }) => pathname.startsWith(link));
    return index !== -1 ? index : -1;
  }, [pathname, headerLabels]);

  const [selectedTab, setSelectedTab] = useState<number>(initialSelectedTab);

  const handleClickGoToMain = () => {
    navigate('/');
  };

  useEffect(() => {
    // 메인 페이지로 이동할 때 selectedTab active 안되도록
    if (
      pathname === '/' ||
      pathname.includes('terms') ||
      pathname.includes('download') ||
      pathname.includes('mypage')
    ) {
      setSelectedTab(-1);
    }
  }, [pathname]);

  return (
    <Header
      labels={headerLabels}
      onClickHeader={handleClickGoToMain}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      isWhite={!pathname.includes('download')}
    />
  );
};

export default Nav;
